// Port of menu_test sections/chart.coffee getAnswer. ec's answer.js is only a structural
// template — the menu math differs (purchaser subtraction, zero-total guards).

import { formatAmount, calcUnitLabel } from '@aytm/app/stats/page/question-views/mn/lib/chart/format'
import { applyUnitTemplate } from '@aytm/app/stats/page/question-views/mn/lib/chart/answer-utils'
import {
  SECTION_PERCENT_CAPABLE_VIEWS,
  VIEW_MODES,
  purchasedCount
} from '@aytm/app/stats/page/question-views/mn/lib/viewOptions'

const SECTIONS_SECONDS_MODES = [VIEW_MODES.ATTENTION, VIEW_MODES.TIME, VIEW_MODES.TIME_TO_FIRST_CLICK]

// Sections answers arrive under sq{position} keys and are remapped to a{position}.
export const getSectionsAnswer = ({ answer, sections, viewMode, priceTemplate, trait, traitName }) => {
  const questionTotal = answer?.total || 0
  const hcAnswers = { total: questionTotal }

  for (const section of sections || []) {
    const sk = `sq${section.position}`
    const ak = `a${section.position}`
    const sv = answer?.[sk] || {}
    const sectionPurchased = purchasedCount(sv)

    const value = {}
    hcAnswers[ak] = value

    if (VIEW_MODES.OPENED === viewMode) {
      value.amount = sv.amount || 0
      value.percents = sv.percents || 0
    } else if (VIEW_MODES.PURCHASED === viewMode) {
      value.amount = sectionPurchased
      value.percents = questionTotal ? (sectionPurchased / questionTotal) * 100 : 0
    } else {
      value.amount = sv[viewMode] || 0
    }
    // shown rounded, sorted on the raw value the table sorts by, so values that round alike keep its order
    value.sortValue = Number(value.amount) || 0
    value.amount = formatAmount(value.amount, viewMode)
    value.unitLabel = calcUnitLabel({
      viewMode,
      amount: value.amount,
      percentCapableViews: SECTION_PERCENT_CAPABLE_VIEWS,
      secondsModes: SECTIONS_SECONDS_MODES
    })
    applyUnitTemplate(value, viewMode, priceTemplate)
    if (VIEW_MODES.OPENED === viewMode && sv.errLO && sv.errHI) {
      value.errLO = sv.errLO
      value.errHI = sv.errHI
    }

    if (trait) {
      const traitBlock = {}
      const svTrait = sv[traitName] || {}
      for (const tk of Object.keys(svTrait)) {
        const tv = svTrait[tk]
        const traitValue = {}
        if (VIEW_MODES.OPENED === viewMode) {
          traitValue.amount = tv.amount || 0
          traitValue.percents = tv.percents || 0
        } else if (VIEW_MODES.PURCHASED === viewMode) {
          // trait % is a share of the section's purchasers, matching opened
          traitValue.amount = purchasedCount(tv)
          traitValue.percents = sectionPurchased ? (traitValue.amount / sectionPurchased) * 100 : 0
        } else {
          traitValue.amount = tv[viewMode] || 0
        }
        traitValue.amount = formatAmount(traitValue.amount, viewMode)
        traitValue.unitLabel = value.unitLabel
        applyUnitTemplate(traitValue, viewMode, priceTemplate)
        traitBlock[tk] = traitValue
      }
      value[traitName] = traitBlock
    }
  }

  return hcAnswers
}
